import Lottie, { type AnimationConfigWithData } from 'lottie-web'
import React, { useEffect, useRef } from 'react'

export const AnimationPlayer = ({
  animationData,
  ...rest
}: Omit<AnimationConfigWithData, 'container'>) => {
  const playerContainer = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!playerContainer.current) return

    playerContainer.current.innerHTML = ''

    Lottie.loadAnimation({
      autoplay: true,
      loop: true,
      ...rest,
      container: playerContainer.current,
      animationData: JSON.parse(JSON.stringify(animationData)),
    })
  }, [])

  return <div ref={playerContainer} />
}
